import getJSONValue from 'nucleus-widgets/utils/fields/getJSONValue';

const identityConfirmationPageId = '1';

/**
 * Get JSON path into a registration path
 * @param regPathId
 * @param path
 */
export function registrationPathJsonPath(regPathId, ...path) {
  return ['registrationSettings', 'registrationPaths', regPathId, ...path];
}

export function identityConfirmationJsonPath(regPathId, ...path) {
  return [...registrationPathJsonPath(regPathId), 'identityConfirmation', ...path];
}

export function accessRulesJsonPath(regPathId, ...path) {
  return [...registrationPathJsonPath(regPathId), 'accessRules', ...path];
}

/**
 * Get JSON path into a registration field
 * @param regPathId
 * @param fieldId
 * @param path
 */
export default function registrationFieldJsonPath(regPathId, fieldId, ...path) {
  return [...registrationPathJsonPath(regPathId),
    'registrationPageFields',
    identityConfirmationPageId,
    'registrationFields',
    fieldId,
    ...path];
}

/**
 * Get JSON path into a sub field of registration field
 * @param regPathId
 * @param fieldId
 * @param path
 */
export function registrationSubFieldJsonPath(regPathId, fieldId, ...path) {
  return [...registrationFieldJsonPath(regPathId, fieldId), 'subFieldDisplayNames', ...path];
}

export function getAppDataRegistrationFieldValue(
  appData, regPathId, fieldId, ...path) {
  return getJSONValue(appData, registrationFieldJsonPath(regPathId, fieldId, ...path));
}
